function Dashboard() {
  return (
    <iframe
      height="2450"
      sandbox="allow-scripts allow-same-origin allow-modals"
      scrolling="yes"
      src="https://st-5-dashboard2.co-creative-labs.com"
      style={{ border: '0px', display: 'block' }}
      width="100%"
      title="Smart Transform 5.0 Dashboard"
    />
  );
}

export default Dashboard;
